import { z } from 'zod'

export const jpPushOptInEntrySchema = z.object({
  n: z.literal('36'),
  seq: z.enum(['A1', 'A2', 'A3', 'B1', 'B2']),
  ch: z.literal('email'),
})
export type JpPushOptInEntry = z.infer<typeof jpPushOptInEntrySchema>

export function resolveJpPushOptInAction(permission: string): 'request' | 'settings' | 'done' | 'wait' {
  if (permission === 'undetermined') {
    return 'request'
  }
  if (permission === 'denied') {
    return 'settings'
  }
  if (permission === 'granted') {
    return 'done'
  }
  return 'wait'
}
